const STATUS = {
  'INTRO': 'intro', // show intro animation
  'INTRO_BAD_PAIR': 'intro-bad-pair', // phase 2 of intro animation showing matched cards
  'INTRO_GOOD_PAIR': 'intro-good-pair', // phase 3 of intro animation showing matched cards
  'INTRO_END': 'intro-end', // fade the cards out in the background and flip the matching cards back
  'LOGO': 'logo', // show the logo
  'GAME_START': 'game-start', // slide in cards
  'GAME_PLAY': 'game-play', // render interactive cards
  'GAME_END': 'game-end', // show end message and CTA
}

export default STATUS;



// WEBPACK FOOTER //
// ./src/components/du/Game/Constants.js